import {
  MTO_FIELD_FILTER_REQUEST,
  MTO_FIELD_FILTER_REQUEST_SUCCESS,
  MTO_FIELD_FILTER_REQUEST_FAILURE,
  MTO_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: true,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const mtoFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MTO_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MTO_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case MTO_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MTO_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default mtoFilterFieldsReducer;
